var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"afd84f41e35f4db347eedaa95fe91f08037924fa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["everest@noissue"]={id:"afd84f41e35f4db347eedaa95fe91f08037924fa"};
      